import {
  Component, Input, Output, OnInit, ElementRef, EventEmitter,
  Injectable, OnChanges, Renderer2, OnDestroy, ViewEncapsulation, Inject
} from '@angular/core';
import {trigger, state, style, animate, transition} from '@angular/animations';
import { AbsTabComponent } from './abs-tab.component';

@Component({
  selector: 'abs-tab-group',
  template: `<div id="{{acId}}tab{{index}}" [attr.aria-posinset]="index+1" class="toggle-header" [attr.aria-expanded]="isOpen" [attr.aria-controls]="acId + 'panel' + index" [attr.aria-setsize]="groupSize" [ngClass]="{'opened': isOpen, 'closed': !isOpen, 'filter': isFilter, 'filter-first-child': isFilter && (index =='0')}" role="tab" (click)="toggle()"  [style.border-bottom]="isOpen ? 0:''" [tabindex]="-1" >
  <i [ngClass]="{'icon-accordion-plus':!isOpen,'icon-accordion-minus':isOpen}"></i>
<span>{{heading}} <span class="hidden-spoken" *ngIf="isOpen && isMobile ">Expanded</span><span class="hidden-spoken" *ngIf="!isOpen && isMobile">Collapsed</span></span>
</div>
<div class="accordion-content" [@expand]="isOpen ? 'ddh-collapse-in' : 'ddh-collapse'" [attr.aria-labelledby]="acId + 'tab' + index" id="{{acId}}panel{{index}}" role="tabpanel"  [ngClass]="{'make-all-white': onDark,'filter':isOpen && isFilter,'has-nested': hasNested}" >
<ng-content></ng-content>
</div>`,
  styles: [`.inactive-toggle-header,.toggle-header{border-color:#fff;color:#0568ae;cursor:pointer;display:block;font-size:2rem;line-height:1.2rem;min-height:41px;position:relative;padding:16px 55px 16px 15px}.tiny-accordion-to-tabs>abs-tab-group>.toggle-header{background-clip:padding-box;background-color:#fff;border-bottom:1px solid #d2d2d2;border-radius:0;border-right:1px solid #d2d2d2;border-top:1px solid #fff;display:inline-block;-webkit-filter:none;filter:none;float:left;font-weight:400;height:70px;padding:26px 20px 25px;text-align:center;white-space:nowrap}.tiny-tabs .toggle-header{height:71px;padding:22px 20px 25px!important;border-top:5px solid #fff}.tiny-tabs .toggle-header+div{left:0;position:absolute;top:69px;border-top:1px solid #d2d2d2;padding:0;display:block;border-bottom:none;width:100%}.tiny-accordion-to-tabs.row-nowrap>abs-tab-group>.toggle-header{border-right:0;border-left:0}.tiny-accordion-to-tabs.row-nowrap>abs-tab-group>.toggle-header.closed:last-child,.tiny-accordion-to-tabs>abs-tab-group:last-of-type>.toggle-header:not(.opened){border-right:none}.tiny-accordion-to-tabs,.tiny-tabs{position:relative;width:100%;margin:0;padding:0}.tiny-accordion-to-tabs:after,.tiny-accordion-to-tabs:before,.tiny-tabs:after,.tiny-tabs:before{display:table;content:"";line-height:0}.tiny-accordion-to-tabs:after,.tiny-tabs:after{clear:both}.tiny-tabs .toggle-header.opened{border-bottom:0!important}.tiny-tabs .opened:nth-last-of-type(2){border-right:1px solid #d2d2d2}.tiny-tabs .opened:first-child{border-left:1px solid #d2d2d2}.tiny-tabs .toggle-header:first-child{margin-left:0}.tiny-tabs .opened{color:#191919;border-top:none!important;padding-top:27px!important;border-bottom:none;background-color:#fff;-webkit-filter:none;filter:none;cursor:default;z-index:999}.toggle-header.opened{color:#191919}.focus--mouse,.focus-mouse{outline:0}[aria-controls]{cursor:pointer}.tiny-tabs .opened:before{content:"";background-color:#0568ae;height:5px;width:100%;position:absolute;top:0;left:0}.tiny-tabs [class*=icon-accordion-]{display:none!important}.toggle-header .icon-accordion-minus,.toggle-header .icon-accordion-plus{display:inline-block;font-size:20px;margin-top:-13px;padding:0;position:absolute;right:15px;vertical-align:middle;top:50%}.accordion-content{-webkit-transition:max-height 1s;transition:max-height 1s;overflow:hidden;font-size:1.6rem}.accordion-pad{padding-top:30px}@media (min-width:768px){.tiny-accordion-to-tabs .toggle-header+div,.tiny-tabs .toggle-header+div{left:0;position:absolute;top:69px;border-top:1px solid #d2d2d2;padding-top:30px;padding-left:20px;display:block;border-bottom:none;width:100%}.tiny-tabs .toggle-header+div .accordion-pad{padding-top:0;padding-bottom:0}}.tiny-accordion-to-tabs .toggle-header:first-child{margin-left:0}.tiny-accordion-to-tabs .opened{background-color:#fff;border-bottom:none;color:#191919;cursor:default;-webkit-filter:none;filter:none;padding-top:22px!important;text-decoration:none;z-index:999}@media (max-width:767px){.tiny-accordion-to-tabs{display:block;border-bottom:1px solid #d2d2d2}.tiny-accordion,.tiny-accordion-to-tabs{margin-left:-15px;margin-right:-15px;width:auto}.tiny-accordion-to-tabs div.toggle-header+.accordion-content{padding:0 50px 15px 15px}.tiny-accordion-to-tabs div.toggle-header .icon-accordion-plus{background-position:0 0;background-size:20px 40px}.tiny-accordion-to-tabs div.toggle-header{display:block!important;float:none;text-align:left;border-top:1px solid #ccc!important;border-bottom:0;border-right:0;padding:16px 50px 16px 15px!important;height:47px}.tiny-accordion-to-tabs div.toggle-header:first-child{margin-left:0!important}.tiny-accordion-to-tabs .toggle-header{display:block;min-height:41px;padding:16px 50px 16px 15px;border-top:1px solid #d2d2d2}.tiny-accordion-to-tabs .toggle-header:focus{text-decoration:none}}@media (min-width:768px){.tiny-accordion-to-tabs>abs-tab-group:first-of-type>.toggle-header.opened{border-left:1px solid #d2d2d2}.tiny-accordion-to-tabs.row-nowrap>abs-tab-group>.toggle-header{border-right:1px solid #d2d2d2;border-left:0}.tiny-accordion-to-tabs .opened{color:#191919;border-top:none!important;padding-top:27px!important;border-bottom:none;background-color:#fff;-webkit-filter:none;filter:none;cursor:default;text-decoration:none;z-index:999}.tiny-accordion-to-tabs .opened:nth-last-of-type(2){border-right:1px solid #d2d2d2}.tiny-accordion-to-tabs .opened:first-child{border-left:1px solid #d2d2d2}.tiny-accordion-to-tabs .toggle-header:first-child{border-left:1px solid #fff}.tiny-accordion-to-tabs .toggle-header:nth-last-of-type(2){border-right:none}.tiny-accordion-to-tabs .opened:before{content:"";background-color:#0568ae;height:5px;width:100%;position:absolute;top:0;left:0}.tiny-accordion-to-tabs [class*=icon-accordion-]{display:none!important}}.tiny-accordion{border-bottom:1px solid #d2d2d2}.tiny-accordion .inactive-toggle-header,.tiny-accordion .toggle-header{line-height:2.3rem!important;padding:16px 55px 16px 15px;padding-top:14px!important;border-top:1px solid #d2d2d2}.tiny-accordion .toggle-header+.accordion-content{padding:0 50px 15px 15px}`],
  encapsulation: ViewEncapsulation.None,
  animations: [
      trigger('expand', [
          state('ddh-collapse', style({
              display: 'none',
              height: 0
          })),
          state('ddh-collapse-in', style({
              display: 'block',
              height: '*'
          })),
          transition('ddh-collapse => ddh-collapse-in', animate('.3s ease-in-out')),
          transition('ddh-collapse-in => ddh-collapse', animate('.3s ease-in-out'))
      ])]
})

@Injectable()
export class AbsTabGroupComponent implements OnInit, OnChanges, OnDestroy {
  public onDark = false;
  public panel: any;
  public tab: any;
  public output: any;
  public acId;
  public index;
  public scrollTop;
  public isFilter;
  public groupSize: any;
  public isSelected: any;
  public accordionPanelHeight;
  public accordionPanelHeightRatio;
  public isMobile = /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  @Input('heading') public heading: any;  //  Heading for each accordion group
  @Input('isOpen') public isOpen: any;    // Property to show open accordion group by default
  @Input('isDisabled') public isDisabled: any; // To show if the accordion group is disabled by default
  @Input('hasNested') public hasNested: any; // To show if the accordion content section has nested accordion
  @Output() public isOpenChange: EventEmitter<any> = new EventEmitter(); // To send the response to model for the current opened group
  @Output() public functionOnExpand: EventEmitter<any> = new EventEmitter(); // To expose a function to perform something on expand
  @Output() public functionOnCollapse: EventEmitter<any> = new EventEmitter(); // To expose a function to perform something on collapse
  constructor(
      @Inject(AbsTabComponent) public accordion: AbsTabComponent,
      @Inject(ElementRef) public element: ElementRef,
      @Inject(Renderer2) public renderer: Renderer2) {
  }
  ngOnInit() {
      this.accordionPanelHeight = this.element.nativeElement.children[1].offsetHeight + 80;
      this.accordionPanelHeightRatio = window.innerHeight / this.accordionPanelHeight;
      this.isFilter = this.accordion.isFilter;
      // to initialize variables used in templates or component if undefined or if needed from parent
      this.acId = this.accordion.accordionID;
      this.index = this.accordion.index;
      if (this.isOpen === undefined) {
          this.isOpen = false;
      }
      if (this.hasNested === undefined) {
          this.hasNested = false;
      }
      this.scrollTop = this.accordion.scrollTop;
      // Add each group to the parent group array
      if (this.accordion.groups.length === 0) {
          var instance = this;
          setTimeout(() => { instance.element.nativeElement.children[0].tabIndex = 0 }, 300);
      }
      this.accordion.addGroup(this);
      // Find the refrence for the tab and pannel inside accordion-group
      this.tab = this.element.nativeElement.children[0];
      this.panel = this.element.nativeElement.children[1];
      var instance = this;
      setTimeout(() => {
          // To set pannel height for tiny tabs and tiny accordion to tabs type 
          if (instance.accordion.hasClass(instance.element.nativeElement.parentElement, 'tiny-tabs') ||
              instance.accordion.hasClass(instance.element.nativeElement.parentElement, 'tiny-accordion-to-tabs')) {
              if (instance.panel === undefined) {
                  return;
              }
              let panelheight = instance.panel.offsetHeight;
              panelheight = panelheight + 80;
              if (panelheight === 80) {
                  return;
              }
              instance.accordion.setHeight(panelheight);
              instance.accordion.elementHeight(this.panel.offsetHeight, panelheight);
          }
          instance.groupSize = instance.accordion.getSize();
      }, 200);
      // If element has class "onDark then variable is set to true which makes background css dark and font light"
      if (this.hasClass(this.element.nativeElement.parentElement, 'on-dark')) {
          this.onDark = true;
      }
      // Binding key events on accordion
      this.renderer.listen(this.tab, 'keydown', (event) => {
          this.handleKeydown(event);
      });

      this.renderer.listen(window, 'orientationchange', (e) => {
          if (instance.tab.className.indexOf('opened') > -1) {
              var newHeight = window.innerHeight / instance.accordionPanelHeightRatio;
              instance.accordion.setHeight(newHeight);
          }
      })
          this.renderer.listen(window, 'resize', (e) => {
          if (instance.tab.className.indexOf('opened') > -1) {
              var newHeight = window.innerHeight / instance.accordionPanelHeightRatio;
              instance.accordion.setHeight(newHeight);
          }
      })
  }

  ngOnChanges(changes) {
      // if is Open for any particular accordion is found true, based on variable close other for that accordion
      // function is called which will open this accordion-group and rest group depending on closeOthers variable value
      if (changes.isOpen !== undefined) {
          this.setTabIndex(changes.isOpen.currentValue);
          /*if (changes.isOpen.currentValue === true) {
              this.accordion.fnCloseOthers(this, this.accordion.closeOthers);
              if (this.accordion.hasClass(this.element.nativeElement.parentElement, 'tiny-tabs') ||
                  this.accordion.hasClass(this.element.nativeElement.parentElement, 'tiny-accordion-to-tabs')) {
                  var instance = this;
                  instance.accordion.setHeight(this.accordionPanelHeight);
                  if (instance.panel === undefined || (instance.accordionPanelHeight === null || instance.accordionPanelHeight === undefined)) {
                      return;
                  } else {
                      var newHeight = window.innerHeight / this.accordionPanelHeightRatio;
                      instance.accordion.setHeight(newHeight);
                  }
              }
          }*/
      }
  }

  ngOnDestroy() {
      // on destroy we are reving the group from the accordiongroup array . this is the last thing which gets executed
      this.accordion.removeGroup(this);
  }

  public toggle() {
      // if group is not disabled then based on clases we assign isOpen Properties to give the toggle expanding/collapsing effect
      if (!this.isDisabled) {
          if (this.accordion.hasClass(this.accordion.element.nativeElement, 'tiny-tabs')) {
              this.isOpen = true;
          } else if (this.accordion.hasClass(this.accordion.element.nativeElement, 'tiny-accordion-to-tabs')) {
              if (window.innerWidth < 767) {
                  this.isOpen = !this.isOpen;
              } else {
                  this.isOpen = true;
              }
          } else {
              this.isOpen = !this.isOpen;
          }

          // To set focus on current group
          this.accordion.focus(this);
          // Emiting the value true for the accordion group which is focused and returning false for rest
          if (this.isOpen) {
              for (let i = 0; i < this.accordion.groups.length; i++) {
                  if (this === this.accordion.groups[i]) {
                      this.isOpenChange.emit(true);
                  } else {
                      this.accordion.groups[i].isOpenChange.emit(false);
                  }
              }
              // Emiting value for functionOnExpand so that true to this will result in a function triggered on user side
              this.functionOnExpand.emit(true);
          } else {
              for (let i = 0; i < this.accordion.groups.length; i++) {
                  if (this === this.accordion.groups[i]) {
                      this.isOpenChange.emit(false);
                  }
              }
              // Emiting value for functionOnCollapse so that true to this will result in a function triggered on user side
              this.functionOnCollapse.emit(false);
          }
      }
      this.accordion.deSelectOthers(this);

      if (this.scrollTop) {
          //            var instance = this;
          //            setTimeout(() => {
          this.accordion.scrollTo(this.element.nativeElement);
          //            }, 600);
      }

      this.setTabIndex(this.isOpen);        

  }

  public setTabIndex(val){
      if (val === true) {
          this.accordion.fnCloseOthers(this, this.accordion.closeOthers);
          if (this.accordion.isCloseOthers() && this.tab)
              {
                  this.tab.tabIndex = 0; 
              }
              //this.panel.tabIndex = -1;
          if (this.accordion.hasClass(this.element.nativeElement.parentElement, 'tiny-tabs') ||
              this.accordion.hasClass(this.element.nativeElement.parentElement, 'tiny-accordion-to-tabs')) {
              var instance = this;
              instance.accordion.setHeight(this.accordionPanelHeight);
              if (instance.panel === undefined || (instance.accordionPanelHeight === null || instance.accordionPanelHeight === undefined)) {
                  return;
              } else {
                  var newHeight = window.innerHeight / this.accordionPanelHeightRatio;
                  instance.accordion.setHeight(newHeight);
              }
          }
      }
      else if (val === false) {
          if (this.accordion.isCloseOthers() && !this.accordion.isLastOpen() && this.tab)
          {
              this.tab.tabIndex = -1;
          }
      }
  }
  
  public hasClass(element, className) {
      return (element.className.indexOf(className) > -1) ? true : false;
  }

  public fixUpCSS(element, cssObject) {
      for (let key = 0; key < Object.keys(cssObject).length; key++) {
          element.style[Object.keys(cssObject)[key]] = cssObject[Object.keys(cssObject)[key]];
      };
  };
  
  public keymap() {
      return {
          KEY: {
              TAB: 9,
              ENTER: 13,
              ESC: 27,
              SPACE: 32,
              LEFT: 37,
              UP: 38,
              RIGHT: 39,
              DOWN: 40,
              SHIFT: 16,
              CTRL: 17,
              ALT: 18,
              PAGE_UP: 33,
              PAGE_DOWN: 34,
              HOME: 36,
              END: 35,
              BACKSPACE: 8,
              DELETE: 46,
              COMMAND: 91
          },
          MAP: {
              91: 'COMMAND',
              8: 'BACKSPACE',
              9: 'TAB',
              13: 'ENTER',
              16: 'SHIFT',
              17: 'CTRL',
              18: 'ALT',
              19: 'PAUSEBREAK',
              20: 'CAPSLOCK',
              27: 'ESC',
              32: 'SPACE',
              33: 'PAGE_UP',
              34: 'PAGE_DOWN',
              35: 'END',
              36: 'HOME',
              37: 'LEFT',
              38: 'UP',
              39: 'RIGHT',
              40: 'DOWN',
              43: '+',
              44: 'PRINTSCREEN',
              45: 'INSERT',
              46: 'DELETE',
              48: '0',
              49: '1',
              50: '2',
              51: '3',
              52: '4',
              53: '5',
              54: '6',
              55: '7',
              56: '8',
              57: '9',
              59: ';',
              61: '=',
              65: 'A',
              66: 'B',
              67: 'C',
              68: 'D',
              69: 'E',
              70: 'F',
              71: 'G',
              72: 'H',
              73: 'I',
              74: 'J',
              75: 'K',
              76: 'L',
              77: 'M',
              78: 'N',
              79: 'O',
              80: 'P',
              81: 'Q',
              82: 'R',
              83: 'S',
              84: 'T',
              85: 'U',
              86: 'V',
              87: 'W',
              88: 'X',
              89: 'Y',
              90: 'Z',
              96: '0',
              97: '1',
              98: '2',
              99: '3',
              100: '4',
              101: '5',
              102: '6',
              103: '7',
              104: '8',
              105: '9',
              106: '*',
              107: '+',
              109: '-',
              110: '.',
              111: '/',
              112: 'F1',
              113: 'F2',
              114: 'F3',
              115: 'F4',
              116: 'F5',
              117: 'F6',
              118: 'F7',
              119: 'F8',
              120: 'F9',
              121: 'F10',
              122: 'F11',
              123: 'F12',
              144: 'NUMLOCK',
              145: 'SCROLLLOCK',
              186: ';',
              187: '=',
              188: ',',
              189: '-',
              190: '.',
              191: '/',
              192: '`',
              219: '[',
              220: '\\',
              221: ']',
              222: "'"
          },
          isNumericKey(e) {
              const k = e.keyCode;
              if ((k >= 48 && k <= 57) || (k >= 96 && k <= 105)) {
                  return true;
              } else {
                  return false;
              }
          }
      };
  }
  
  handleKeydown(ev) {
      const boolFlag = true;
      switch (ev.keyCode) {
          case this.keymap().KEY.ENTER:
              ev.preventDefault();
              // On enter we toggle the state of accordion from expand to collapse  or collapse to expand
              this.toggle();
              break;
          case this.keymap().KEY.SPACE:
              ev.preventDefault();
              // On enter we toggle the state of accordion from expand to collapse  or collapse to expand
              this.toggle();
              break;
          case this.keymap().KEY.UP:
          case this.keymap().KEY.LEFT:
              ev.preventDefault();
              // on key up or left going to previous accordion-group of accordion
              this.accordion.cycle(this, false);
              if ((this.accordion.hasClass(this.accordion.element.nativeElement, 'tiny-accordion-to-tabs') ||
                  this.accordion.hasClass(this.accordion.element.nativeElement, 'tiny-tabs'))) {
                  this.accordion.groups[this.index].toggle();
              }
              break;
          case this.keymap().KEY.DOWN:
          case this.keymap().KEY.RIGHT:
              ev.preventDefault();
              // on key down or right going to next accordion-group of accordion
              this.accordion.cycle(this, true);
              if ((this.accordion.hasClass(this.accordion.element.nativeElement, 'tiny-accordion-to-tabs') ||
                  this.accordion.hasClass(this.accordion.element.nativeElement, 'tiny-tabs'))) {
                  this.accordion.groups[this.index].toggle();
              }
              break;
          default:
              break;
      }
      return boolFlag;
  }
}